import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Base from '../base';
import { Alert } from '@themesberg/react-bootstrap';
import FormVehicleService from '../../components/forms/config/form.services';

function EditServices() {
  const {id} = useParams();
  const [alert, setAlert] = useState({
    show: false,
    message: '',
    type:''
  });


  const upsertService = ({message , type}) => {
    setAlert({ show: true, message , type });
  };

  useEffect(() => {}, [id]);
  return (
    <Base>
      {alert.show && <Alert variant={alert.type} onClose={() => setAlert({show: false})} dismissible>{alert.message}</Alert>}
      <FormVehicleService idService={id}  callback={upsertService}></FormVehicleService>
    </Base>
  );
}

export default EditServices;
